var HPEConstants = require('../../base/hpe.constants');
var DynamicTabContainerController = require('./hpe.dynamic.tab.container.controller');
var availableComponents = {};

//list of available components that this dynamic tab instance may use (if so configured via AEM/sightly)
var htmlLoaderTab = require('../htmlloadertab/hpe.html.loader.tab.controller');
var productListTab = require('../productlisttab/hpe.product.list.tab.controller');

module.exports = (function () {

	function initialize() {
    // Validate if Dynamic Tab Container exists
    if (!document.querySelector('.dynamic-tab-container')) return false;

    //map list of available components required above to hpe.componentclass constants representing these components
    availableComponents[HPEConstants.componentclass.OVERVIEW] = htmlLoaderTab;
    availableComponents[HPEConstants.componentclass.SPECIFICATIONS] = htmlLoaderTab;
    availableComponents[HPEConstants.componentclass.MODELS] = productListTab;
    availableComponents[HPEConstants.componentclass.OPTIONS] = productListTab;
    availableComponents[HPEConstants.componentclass.SERVICES] = productListTab;
    availableComponents[HPEConstants.componentclass.COMPATIBLEPRODUCTS] = htmlLoaderTab;

    //new instance of dynamic tab container with custom options
    return new DynamicTabContainerController({ availableComponents });
  }

  return { initialize };
})();
